import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'creator',
		pluralName: 'creators',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
